"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "grotteria": {
    "7426200b": [{
      "hkey": "631c84ec",
      "slug": "aspalmo",
      "name": "Aspalmo",
      "primary": true,
      "skipSearch": false
    }],
    "aspalmo-inferiore": [{
      "hkey": "631c84ec",
      "slug": "aspalmo",
      "name": "Aspalmo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7ddb587b": [{
      "hkey": "631c84ec",
      "slug": "aspalmo",
      "name": "Aspalmo",
      "primary": true,
      "skipSearch": false
    }],
    "aspalmo-superiore": [{
      "hkey": "631c84ec",
      "slug": "aspalmo",
      "name": "Aspalmo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "grotteria"
    }],
    "fa71ef4a": [{
      "hkey": "f4aad215",
      "slug": "grotteria",
      "name": "Grotteria",
      "primary": true,
      "skipSearch": false
    }],
    "pirgo": [{
      "hkey": "f4aad215",
      "slug": "grotteria",
      "name": "Grotteria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;